var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcExcWBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20.2829,
    fill: "#FFC90C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3616 5.82917L10.5 11.0001L9.6384 5.82917C9.61773 5.70413 9.62453 5.5761 9.65831 5.45396C9.6921 5.33181 9.75206 5.21848 9.83404 5.12184C9.91602 5.0252 10.0181 4.94756 10.133 4.89431C10.248 4.84106 10.3733 4.81348 10.5 4.81348C10.6267 4.81348 10.7519 4.84106 10.8669 4.89431C10.9819 4.94756 11.084 5.0252 11.1659 5.12184C11.2479 5.21848 11.3079 5.33181 11.3417 5.45396C11.3755 5.5761 11.3822 5.70413 11.3616 5.82917Z",
    stroke: "black",
    strokeWidth: 2.06287,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.4695C10.8798 15.4695 11.1876 15.1616 11.1876 14.7819C11.1876 14.4021 10.8798 14.0942 10.5 14.0942C10.1202 14.0942 9.81238 14.4021 9.81238 14.7819C9.81238 15.1616 10.1202 15.4695 10.5 15.4695Z",
    stroke: "black",
    strokeWidth: 1.37525
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExcWBg);
export default __webpack_public_path__ + "static/media/ic-exc-w-bg.d24e14c2727917c2e8289d316fef5e73.svg";
export { ForwardRef as ReactComponent };